import {
  GET_PARTICIPANTS_LIST_ERROR,
  GET_PARTICIPANTS_LIST_INFO,
  GET_PARTICIPANTS_LIST_SUCCESS
} from './ListParticipants.actions'

const initialState = {
  error: false,
  errorOrgCodeValidation: false,
  loading: true,
  active: false,
  creationDate: '',
  externalCode: '',
  participantId: '',
  roleList: [],
  participants: [],
  participantsValidated: []
}

/**
 * The reducer for the Participants List
 */
const participantsListReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_PARTICIPANTS_LIST_INFO: {
      return {
        ...state,
        loading: true,
        error: false,
        errorOrgCodeValidation: false
      }
    }
    case GET_PARTICIPANTS_LIST_ERROR: {
      return {
        ...state,
        errorOrgCodeValidation: payload.errorOrgCodeValidation,
        loading: false,
        error: true
      }
    }
    case GET_PARTICIPANTS_LIST_SUCCESS: {
      return {
        ...state,
        active: payload.active,
        participants: payload.participants,
        participantsValidated: payload.participantsValidated,
        creationDate: payload.creationDate,
        externalCode: payload.externalCode,
        participantId: payload.participantId,
        roleList: payload.roleList,
        loading: false,
        error: false,
        errorOrgCodeValidation: false
      }
    }
    default: {
      return state
    }
  }
}

export default participantsListReducer
